import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as constants from '../util/constants';
import qs from 'qs';
import ReviewsSkeleton from '../components/ReviewsSkeleton/ReviewsSkeleton';

class AppHotelReviewsPage extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allReviews: [],
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    // Bind "this"
    this.loadHotelReviews = this.loadHotelReviews.bind(this);
  }

  loadHotelReviews() {
    const {
      allReviews,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({loading: true});

      // Params
      const data = {
        'action': constants.ACTION_GET_HOTEL_REVIEWS,
        'offset': this.state.allReviews.length,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const reviews = response.data['reviews'];
            const reviewsCount = response.data['reviews_count'];

            if (0 === reviewsCount) {
              this.setState({
                loading: false,
                loadedAll: true,
              });
            } else {
              this.setState({
                loading: false,
                allReviews: [
                  ...allReviews,
                  ...reviews,
                ],
                loadedAll: false,
              });
            }
          } else {
            this.setState({
              loading: false,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentDidMount() {
    // Load reviews on first page load
    this.loadHotelReviews();
  }

  componentDidUpdate() {
    // Equal height for elements
    $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
  }

  render() {
    const {
      loading,
      allReviews,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            {
              allReviews.map((review, i) => {
                return (
                  <div className="col-12 col-md-6 col-lg-4" key={i}>
                    <div className="review-card bg-white">
                      <div className="inner-text balance-elements">
                        {
                          review['author'].length > 0 && (
                            <div className={'author-name' + ( review['id'].length == 0 ? ' mb-3' : '' )}>
                              { review['author'] }
                            </div>
                          )
                        }
                        {
                          review['id'].length > 0 && (
                            <div className="review-id mb-3">
                              ID: <span className="small">{ review['id'] }</span>
                            </div>
                          )
                        }
                        {
                          review['date_created'].length > 0 && (
                            <div className="date-created mb-4">
                              { review['date_created'] }
                            </div>
                          )
                        }
                        {
                          review['title'].length > 0 && (
                            <div className="title mb-3">
                              { review['title'] }
                            </div>
                          )
                        }
                        {
                          review['text'].length > 0 && (
                            <div className="text" dangerouslySetInnerHTML={{__html: review['text']}} />
                          )
                        }
                        {
                          review['full_text'].length > 0 && (
                            <div className="full-text d-none">
                              { review['full_text'] }
                            </div>
                          )
                        }
                      </div>
                      <div className="inner-footer d-flex align-items-center justify-content-between">
                        {
                          review['stars'].length > 0 && (
                            <div className="stars" dangerouslySetInnerHTML={{__html: review['stars']}} />
                          )
                        }
                        <div className="rydges-verified bg-center" />
                      </div>
                    </div>
                  </div>
                );
              })
            }
          </div>
          {
            loading && (
              <ReviewsSkeleton />
            )
          }
          <div className="row justify-content-center">
            <button className="btn btn-red btn-lg btn-border-red btn-load-more mt-3" disabled={loading || loadedAll} onClick={this.loadHotelReviews}>
              {!loadedAll ? 'Load More' : 'That\'s All'}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded
    const body = $('body');

    // Reviews
    const reviewsWrapper = $('#hotel-reviews-wrapper');
    if (reviewsWrapper.length) {
      ReactDOM.render(<AppHotelReviewsPage />, reviewsWrapper[0]);

      const hotelReviewModal = $('.hotel-review-modal');
      const hotelReviewModalTitle = hotelReviewModal.find('.review-title');
      const hotelReviewModalText = hotelReviewModal.find('.review-text');
      const hotelReviewModalAuthor = hotelReviewModal.find('.review-author');

      $(document).on('click', '.review-modal-trigger', function(e) {
        e.preventDefault();

        const thisReviewCard = $(e.target).closest('.review-card');
        const reviewTitle = thisReviewCard.find('.title').html();
        const reviewText = thisReviewCard.find('.full-text').html();
        const reviewAuthor = thisReviewCard.find('.author-name').html();

        hotelReviewModalTitle.html(reviewTitle);
        hotelReviewModalText.html(reviewText);
        hotelReviewModalAuthor.html('- ' + reviewAuthor);
        body.addClass('review-modal-open');

        return false;
      });

      $(document).on('click', '.review-modal-close', function(e) {
        e.preventDefault();

        body.removeClass('review-modal-open');
        hotelReviewModalTitle.html();
        hotelReviewModalText.html();
        hotelReviewModalAuthor.html();

        return false;
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelReviews.js